// The gerund of a Button's verb, for its busy label ("Send" -> "Sending…"). The
// label can carry the verb anywhere, and other words
// besides it ("Send reply", "Squash and merge"), so this scans every word rather than
// assuming position. The map is irregular on purpose: suffix rules ("Close" -> drop the
// e) don't generalize, and the verb set a card can run is closed.
const RUNNING_VERB: Record<string, string> = {
  send: 'Sending',
  create: 'Creating',
  add: 'Adding',
  move: 'Moving',
  delete: 'Deleting',
  complete: 'Completing',
  reopen: 'Reopening',
  post: 'Posting',
  merge: 'Merging',
  approve: 'Approving',
  update: 'Updating',
  close: 'Closing',
  react: 'Reacting',
  comment: 'Posting',
  assign: 'Updating',
  unassign: 'Updating',
  mark: 'Updating',
  set: 'Updating',
  start: 'Starting',
};

export function runningVerb(label: string): string {
  for (const word of label.split(/\s+/)) {
    const gerund = RUNNING_VERB[word.toLowerCase()];
    if (gerund) return gerund;
  }
  return label;
}
